/* eslint-disable @angular-eslint/prefer-inject */
import { Component, inject, signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { assets } from '../../core/constants/assets.const';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BulkErrorModalComponent } from '../bulk-error-modal/bulk-error-modal.component';
import { BusinessMemberService } from '../../service/businessMember.service';
import { McqQuestionsService } from '../../service/mcq-questions.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'notchmark-add-employee',
      standalone: true,
    imports: [ButtonModule],
    templateUrl: './add-employee.component.html',
    styleUrl: './add-employee.component.scss',
     providers: [DialogService],
})
export class AddEmployeeComponent {
  assetsConst = assets;
   title = 'Add Employees';
  subTitle = 'Upload Members File';
  description: SafeHtml;
  selectedFile = signal<File | null>(null);
    isUploading = signal<boolean>(false);

      private uploadType = 'member';
  private additionalData: any = {};

    private dialogservice = inject(DialogService);
    private businessService = inject(BusinessMemberService);
      private mcqService = inject(McqQuestionsService);
  constructor(
    private ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private sanitizer: DomSanitizer
  ) {
    this.title = this.config.data?.title || this.title;
    this.subTitle = this.config.data?.subTitle || this.subTitle;

    const desc = this.config.data?.description || 'You can upload an Members file from here or drag and <span class="d_block"> drop. (CSV/Excel)</span>';
    this.description = this.sanitizer.bypassSecurityTrustHtml(desc);

     this.uploadType = this.config.data?.uploadType || 'member';
    this.additionalData = this.config.data?.additionalData || {};
  }

  onFileSelect(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
  
    this.selectedFile.set(input.files[0]);
  }

  submitBulkUpload() {
    if (!this.selectedFile()) {
      return;
    }
  
    this.isUploading.set(true);
    const formData = new FormData();
    formData.append("file", this.selectedFile() as File);
    this.appendAdditionalData(formData);
    const apiCall = this.getApiCall(formData);
    
    apiCall.subscribe({
      next: (response) => {
        this.isUploading.set(false);
        this.ref.close({ success: true, data: response });
      },
      error: (error) => {
        console.error('Upload failed', error);
        this.isUploading.set(false);
        const errorData = error.error || error;
        const errorMessages = this.extractErrorMessages(errorData);
        this.openErrorModal(errorMessages);
      }
    });
  }

  private appendAdditionalData(formData: FormData): void {
    switch (this.uploadType) {
      case 'question':
        if (this.additionalData.practiceSetId) {
          formData.append("practiceSetId", this.additionalData.practiceSetId);
        }
        break;
      case 'member':
        if (this.additionalData.departmentId) {
          formData.append("departmentId", this.additionalData.departmentId);
        }
        break;
    }
  }

  private getApiCall(formData: FormData): Observable<any> {
    switch (this.uploadType) {
      case 'question':
        return this.mcqService.bulkUploadQuestions(formData);
      case 'member':
        return this.businessService.bulkUploadMember(formData);
      default:
        throw new Error(`Unknown upload type: ${this.uploadType}`);
    }
  }
private extractErrorMessages(errorData: any): { count: number; errors: string[] } {
  if (Array.isArray(errorData)) {
    return {
      count: errorData.length,
      errors: errorData
    };
  }
  else if (errorData.errors && Array.isArray(errorData.errors)) {
    return {
      count: errorData.errors.length,
      errors: errorData.data
    };
  }
  else if (errorData.message) {
    return {
      count: 1,
      errors: [errorData.data]
    };
  }
  else {
    return {
      count: 1,
      errors: ['An unexpected error occurred during upload']
    };
  }
}


  private openErrorModal(errorData: { count: number; errors: string[] }) {
    this.ref.close(); // Close current dialog
    
    const errorRef = this.dialogservice.open(BulkErrorModalComponent, {
      style: { width: "100%", maxWidth: "510px" },
      dismissableMask: true,
      styleClass: "bulk_error_modal",
      data: {
        errorCount: errorData.count,
        errorList: errorData.errors
      }
    });
    
    errorRef.onClose.subscribe((retry) => {
      if (retry) {
        // Reopen the upload dialog if user wants to retry
        this.reopenUploadDialog();
      }
    });
  }

  private reopenUploadDialog() {
    this.dialogservice.open(AddEmployeeComponent, {
      style: { width: '100%', maxWidth:'750px' },
      dismissableMask: true,
      styleClass: 'add_employee_modal',
      data: this.config.data
    });
  }

  

  closeDialog() {
    this.ref.close(false);
  }
}
